import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState(''); // '' | 'loading' | 'done' | 'error'

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubStatus('loading');
    try {
      await api.post('/auth/subscribe', { email });
      setSubStatus('done');
      setEmail('');
    } catch { setSubStatus('error'); }
  };

  const linkStyle = { color: '#9ca3af', fontSize: 14, textDecoration: 'none', transition: 'color 0.15s' };
  const headStyle = { color: '#fff', marginBottom: 18, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1.5, fontWeight: 700 };

  return (
    <footer style={{ background: '#0f0f1a', color: '#ccc', marginTop: 60 }}>

      {/* ── Newsletter banner ── */}
      <div style={{ background: 'linear-gradient(135deg,#4f46e5,#7c3aed)', padding: '40px 24px' }}>
        <div style={{ maxWidth: 560, margin: '0 auto', textAlign: 'center' }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 2, color: 'rgba(255,255,255,0.7)', marginBottom: 8, textTransform: 'uppercase' }}>Join the StyleMe Family</div>
          <h3 style={{ color: 'white', fontSize: 24, fontWeight: 900, margin: '0 0 8px' }}>Get 10% Off Your First Order</h3>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 14, margin: '0 0 24px' }}>Subscribe for exclusive deals, new arrivals & style inspiration.</p>
          {subStatus === 'done' ? (
            <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 12, padding: '14px 20px', color: 'white', fontWeight: 700 }}>
              🎉 Check your email for your 10% off code!
            </div>
          ) : (
            <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: 8, maxWidth: 420, margin: '0 auto' }}>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="Your email address"
                style={{ flex: 1, padding: '12px 16px', borderRadius: 10, border: 'none', fontSize: 14, outline: 'none' }}
              />
              <button type="submit" disabled={subStatus === 'loading'}
              style={{ background: '#1e1b4b', color: 'white', border: 'none', borderRadius: 10, padding: '12px 22px', fontWeight: 700, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                {subStatus === 'loading' ? '...' : 'Subscribe →'}
              </button>
            </form>
          )}
          {subStatus === 'error' && <p style={{ color: '#fca5a5', fontSize: 13, marginTop: 8 }}>Something went wrong. Try again.</p>}
        </div>
      </div>

      {/* ── Main footer ── */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '56px 24px 32px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 40, marginBottom: 48 }}>

          {/* Brand */}
          <div>
            <img src="/logo-header.png" alt="StyleMe" style={{ height: 44, width: 'auto', marginBottom: 14, filter: 'brightness(0) invert(1)' }} />
            <p style={{ fontSize: 14, lineHeight: 1.7, color: '#6b7280', marginBottom: 20 }}>
              Your destination for women's fashion, jewelry & accessories. Shop | Style | Shine.
            </p>
            {/* Social icons */}
            <div style={{ display: 'flex', gap: 10 }}>
              {[
                {
                  label: 'Instagram', href: 'https://instagram.com/stylemeclubshop',
                  svg: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                },
                {
                  label: 'Facebook', href: 'https://facebook.com/styleme.club',
                  svg: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                },
              ].map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer" title={s.label}
                  style={{ width: 38, height: 38, borderRadius: 10, background: '#1e1e30', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', textDecoration: 'none', transition: 'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#c9a227'; e.currentTarget.style.color = 'white'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#1e1e30'; e.currentTarget.style.color = '#9ca3af'; }}>
                  {s.svg}
                </a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 style={headStyle}>Shop</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
              <Link to="/shop" style={linkStyle}>All Products</Link>
              <Link to="/shop?category=jewelry" style={linkStyle}>Jewelry</Link>
              <Link to="/shop?category=bracelets" style={linkStyle}>Bracelets</Link>
              <Link to="/shop?category=dresses-tops" style={linkStyle}>Dresses & Tops</Link>
              <Link to="/shop?category=bags-wallets" style={linkStyle}>Bags & Wallets</Link>
              <Link to="/shop?category=hair-accessories" style={linkStyle}>Hair Accessories</Link>
            </div>
          </div>

          {/* Account */}
          <div>
            <h4 style={headStyle}>My Account</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
              <Link to="/orders" style={linkStyle}>My Orders</Link>
              <Link to="/wishlist" style={linkStyle}>My Wishlist</Link>
              <Link to="/addresses" style={linkStyle}>Address Book</Link>
              <Link to="/membership" style={linkStyle}>💎 VIP Membership</Link>
              <Link to="/track" style={linkStyle}>Track Order</Link>
              <Link to="/login" style={linkStyle}>Sign In / Register</Link>
            </div>
          </div>

          {/* Help */}
          <div>
            <h4 style={headStyle}>Help</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
              <Link to="/contact" style={linkStyle}>Contact Us</Link>
              <Link to="/returns" style={linkStyle}>Returns & Refunds</Link>
              <Link to="/privacy" style={linkStyle}>Privacy Policy</Link>
              <Link to="/terms" style={linkStyle}>Terms of Service</Link>
              <Link to="/blog" style={linkStyle}>Style Blog</Link>
            </div>
            <div style={{ marginTop: 24 }}>
              <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.8 }}>
                <div>📧 support@styleme.club</div>
                <div>🚚 Ships in 2–5 business days</div>
                <div>↩️ Free returns within 30 days</div>
              </div>
            </div>
          </div>

        </div>

        {/* ── Payment icons ── */}
        <div style={{ borderTop: '1px solid #1e1e30', paddingTop: 24, marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
            <span style={{ fontSize: 12, color: '#4b5563', marginRight: 4 }}>Secure payments:</span>
            {['Visa', 'Mastercard', 'Amex', 'PayPal', 'Apple Pay', 'Google Pay'].map(p => (
              <span key={p} style={{ background: '#1e1e30', color: '#9ca3af', fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 6, border: '1px solid #2d2d40' }}>{p}</span>
            ))}
            <span style={{ marginLeft: 8, background: '#1e1e30', color: '#4ade80', fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 6, border: '1px solid #2d2d40' }}>🔒 SSL Secured</span>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <span style={{ fontSize: 13, color: '#4b5563' }}>© {new Date().getFullYear()} StyleMe. All rights reserved.</span>
          <span style={{ fontSize: 12, color: '#374151' }}>Made with ♥ for fashion lovers everywhere</span>
        </div>
      </div>
    </footer>
  );
}
